module.exports = __webpack_public_path__ + "media/webfonts/fa-brands-400-f7307680.woff2";